






















import Vue from 'vue'
import { mapState } from 'vuex'
import Navigation from '@/pages/spiders/navigation.vue'

export default Vue.extend({
  components: {
    Navigation,
  },
  computed: mapState({
    sidebar: (state: any) => state.settings.sidebarNavigation,
  }),
  async created() {
    await this.$store.dispatch('users/FETCH')
    await this.$store.dispatch('statuses/FETCH')
    await this.$store.dispatch('plugins/FETCH')
    await this.$store.dispatch('proxies/FETCH')
    await this.$store.dispatch('industries/FETCH')
    await this.$store.dispatch('levels/FETCH')
    await this.$store.dispatch('categories/FETCH')
    await this.$store.dispatch('countries/FETCH')
    await this.$store.dispatch('regions/FETCH')
    await this.$store.dispatch('districts/FETCH')
    await this.$store.dispatch('cities/FETCH')
  },
})
